module.exports = __webpack_public_path__ + "img/panel14.e6bfc74a.jpg";